<template>
    <div>
        <vc-left-menu></vc-left-menu>

        <div :class="{ 'layout-content': true, 'is-active': !getMenuToggle }">
            <div class="page-header-container">
                <div class="page-header">
                    <h3 class="page-title">{{ $t('words.recording_files') }}</h3>
                </div>

                <div class="page-sub-header clearfix">
                    <form class="form-inline float-md-left">
                        <div class="control-group">
                            <label for="select_channel" class="sr-only">{{ $t('words.channel') }}</label>
                            <select id="select_channel" :placeholder="$t('words.channel')">
                            </select>
                        </div>
                        <div class="control-group">
                            <label for="select_live" class="sr-only">{{ $t('words.broadcast') }}</label>
                            <select id="select_live" :placeholder="$t('words.broadcast')">
                            </select>
                        </div>
                    </form>

                    <div class="module-action-group float-md-right">
                        <div class="btn-group btn-group__date">
                            <button :class="{'btn': true, 'active': (period==='1d')}" @click="changePeriod('1d', this)">{{ $t('words.period_today') }}</button>
                            <button :class="{'btn': true, 'active': (period==='3d')}" @click="changePeriod('3d', this)">{{ $t('words.period_3d') }}</button>
                            <button :class="{'btn': true, 'active': (period==='7d')}" @click="changePeriod('7d', this)">{{ $t('words.period_7d') }}</button>
<!--                            <button :class="{'btn': true, 'active': (period==='30d')}" @click="changePeriod('30d', this)">{{ $t('words.period_30d') }}</button>-->
                        </div>
                        <div class="input-group input-group-date input-daterange" id="date-range">
                            <div class="input-group">
                                <vue-date-picker
                                    v-model="rangeDay"
                                    value-type="format"
                                    format="YYYY-MM-DD"
                                    range
                                    placeholder="Select date range"
                                    :disabled-date="notRangedDate"
                                >
                                </vue-date-picker>
                            </div>
                            <div class="input-group-append">
                                <button type="button" :class="{'btn': true, 'btn-icon': true, 'active': (period === 'custom')}" @click.prevent="doSearch"><i class="icon icon-search"></i></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="page-action-group">
                <div class="btn-group mr-auto">
                    <button class="btn btn-danger" @click="doDestroyRecordFiles" v-if="haveManagerRight && (recordingFiles.data.length > 0)"><i class="icon icon-trash"></i>{{ $t('words.remove_recording_file')}}</button>
                </div>

                <nav arititle.channel.hidden_lista-label="Page navigation ml-auto">
                    <ul class="pagination">
                        <li class="page-info">
                            {{ $t('paragraphs.page_navigation', { total: recordingFiles.meta.total, from: ((recordingFiles.meta.current_page - 1) * recordingFiles.meta.per_page + 1), to: (recordingFiles.meta.current_page === recordingFiles.meta.last_page ? recordingFiles.meta.total : recordingFiles.meta.per_page * recordingFiles.meta.current_page )}) }}
                        </li>
                        <li :class="{'page-item': true, disabled: !recordingFiles.links.prev }">
                            <button class="page-link" aria-label="Previous" @click="loadRecordFiles(recordingFiles.links.prev)" v-if="recordingFiles.links.prev">
                                <i class="icon icon-arrow-left-sm" aria-hidden="true"></i>
                                <span class="sr-only">{{ $t('pagination.previous') }}</span>
                            </button>
                            <button class="page-link" aria-label="Previous" v-else>
                                <i class="icon icon-arrow-left-sm" aria-hidden="true"></i>
                                <span class="sr-only">{{ $t('pagination.previous') }}</span>
                            </button>
                        </li>
                        <li :class="{'page-item': true, disabled: !recordingFiles.links.next }">
                            <button class="page-link" aria-label="Next" @click="loadRecordFiles(recordingFiles.links.next)" v-if="recordingFiles.links.next">
                                <i class="icon icon-arrow-right-sm" aria-hidden="true"></i>
                                <span class="sr-only">{{ $t('pagination.next') }}</span>
                            </button>
                            <button class="page-link disabled" aria-label="Previous" disabled v-else>
                                <i class="icon icon-arrow-right-sm" aria-hidden="true"></i>
                                <span class="sr-only">{{ $t('pagination.next') }}</span>
                            </button>
                        </li>
                    </ul>
                </nav>
            </div>

            <div class="page-body">
                <div class="table--responsive">
                    <table class="rec__table">
                        <colgroup>
                            <col width="1%">
                            <col width="1%">
                            <col width="1%">
                            <col>
                            <col>
                            <col width="1%">
                            <col width="1%">
                            <col width="1%">
                            <col width="1%">
                            <col width="1%">
                            <col width="1%">
                        </colgroup>
                        <thead>
                        <tr>
                            <th class="cell__checkbox select-item">
                                <div class="form-checkbox" v-if="haveManagerRight">
                                    <input type="checkbox" id="select_all" :value="true" v-model="selectAll">
                                    <label for="select_all"></label>
                                </div>
                            </th>
                            <th>
                                <span class="btn-order" @click="changeOrder('channel_customer_code_desc')">
                                    {{ $t('words.customer_code') }}
                                    <span class="icon-triangle-wrap">
                                        <i class="icon icon-triangle-up" :class="{'active':order === 'channel_customer_code_asc'}"></i>
                                        <i class="icon icon-triangle-down" :class="{'active':order === 'channel_customer_code_desc'}"></i>
                                    </span>
                                </span>
                            </th>
                            <th>
                                <span class="btn-order" @click="changeOrder('channel_key_desc')">
                                    {{ $t('words.channel_key') }}
                                    <span class="icon-triangle-wrap">
                                        <i class="icon icon-triangle-up" :class="{'active':order === 'channel_key_asc'}"></i>
                                        <i class="icon icon-triangle-down" :class="{'active':order === 'channel_key_desc'}"></i>
                                    </span>
                                </span>
                            </th>
                            <th>
                                <span class="btn-order" @click="changeOrder('channel_title_asc')">
                                    {{ $t('words.channel_name') }}
                                    <span class="icon-triangle-wrap">
                                        <i class="icon icon-triangle-up" :class="{'active':order === 'channel_title_asc'}"></i>
                                        <i class="icon icon-triangle-down" :class="{'active':order === 'channel_title_desc'}"></i>
                                    </span>
                                </span>
                            </th>
                            <th>
                                <span class="btn-order" @click="changeOrder('broadcast_title_asc')">
                                    {{ $t('words.live_title') }}
                                    <span class="icon-triangle-wrap">
                                        <i class="icon icon-triangle-up" :class="{'active':order === 'broadcast_title_asc'}"></i>
                                        <i class="icon icon-triangle-down" :class="{'active':order === 'broadcast_title_desc'}"></i>
                                    </span>
                                </span>
                            </th>
                            <th>{{ $t('words.recording_started_at') }}</th>
                            <th>{{ $t('words.recording_ended_at') }}</th>
                            <th class="text-right">{{ $t('words.filesize') }}(GiB)</th>
                            <th>{{ $t('words.recording_type')}}</th>
                            <th>{{ $t('words.play_now')}}</th>
                            <th>{{ $t('words.recording_download')}}</th>
                        </tr>
                        </thead>
                        <tbody v-if="recordingFiles.load && (recordingFiles.meta.total !== 0)">
                        <tr v-for="recordingFile in recordingFiles.data" :key="recordingFile.id">
                            <td>
                                <div class="form-checkbox" v-if="haveManagerRight">
                                    <input type="checkbox" :id="`recordingFile_${recordingFile.id}`" :value="true" v-model="recordingFile.selected" >
                                    <label :for="`recordingFile_${recordingFile.id}`"></label>
                                </div>
                            </td>
                            <td>{{ recordingFile.channel_customer_code }}</td>
                            <td>
                                <span class="list__channel__key text__key">{{ recordingFile.channel_key }}</span>
                            </td>
                            <td>
                                <span class="recFile__channelTitle">{{ recordingFile.channel_title }}</span>
                            </td>
                            <td><span class="list__channel__name" v-tooltip="{ content: recordingFile.broadcast_title, html:false }">{{ recordingFile.broadcast_title }}</span></td>
                            <td class="td__date">{{ recordingFile.started_at | renderDateTime }}</td>
                            <td class="td__date">{{ recordingFile.ended_at | renderDateTime }}</td>
                            <td class="text-right">
                                <span class="filesize" v-if="recordingFile.filesize > 0">
                                    {{ getHumanReadableFilesize(recordingFile.filesize) }}
                                </span>
                            </td>
                            <td class="text-center">
                                <span v-if="recordingFile.kind === 'duplicate'">{{ $t('words.manual')}}</span>
                                <span v-else>{{ $t('words.auto')}}</span>
                            </td>
                            <td class="text-center">
                                <button class="btn--play" @click="doPlayRecordingFile(recordingFile)">
                                    <i class="icon icon-play"></i>
                                </button>
                            </td>
                            <td class="text-center"><a class="btn-icon-xs" :href="getDownloadUrl(recordingFile)"><i class="icon icon-download"></i></a></td>
                        </tr>
                        </tbody>
                        <tbody v-else-if="recordingFiles.load">
                        <tr>
                            <td colspan="11" class="td__message">
                                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 24 24" class="svg-icon svg-icon-alert-circle"><g stroke-linecap="square" stroke-linejoin="miter" stroke-width="2" fill="#adb5bd" stroke="#adb5bd"><circle fill="none" stroke="#adb5bd" stroke-miterlimit="10" cx="12" cy="12" r="11"/> <line data-color="color-2" fill="none" stroke-miterlimit="10" x1="12" y1="7" x2="12" y2="13"/> <circle data-color="color-2" data-stroke="none" cx="12" cy="17" r="1" stroke-linejoin="miter" stroke-linecap="square" stroke="none"/></g></svg>{{ $t('paragraphs.recording_list_empty') }}</td>
                        </tr>
                        </tbody>
                        <tbody v-else>
                        <tr>
                            <td colspan="11" class="td__message"><div class="loader"></div>{{ $t('paragraphs.list_loading') }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class="modal fade" id="playerModal" tabindex="-1" role="dialog">
                <div class="modal-dialog modal-lg" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">{{ $t('words.preview') }}</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <i class="icon icon-close" aria-hidden="true"></i>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div v-if="isPlayerModalOpen">
                                <component playerId="videoPlayer"
                                           ref="videoPlayer"
                                           :is="videoPlayerComponent"
                                           :mediainfo="recordingFile">
                                </component>
                            </div>
                            <p>
                                <small>{{ $t('paragraphs.recording_file.preview_tip1') }}</small>
                            </p>
                            <!--<video id="hls_player" class="video-js vjs-default-skin vjs-16-9" controls></video>-->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import GlobalConfigMixin from '../mixin/GlobalConfigMixin';
import DateTimeMixin from '../mixin/DateTimeMixin';
import videoPlayer from './videoPlayer/VideoPlayer.vue';
import VueDatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

export default {
    mixins: [
        GlobalConfigMixin,
        DateTimeMixin,
    ],
    components: {
        vueVideoPlayer: videoPlayer,
        VueDatePicker,
    },
    data() {
        return {
            order: 'id_desc',
            selectAll: false,
            selectedChannel: '',
            selectize_channels: null,
            selectize_broadcasts: null,
            selectedBroadcast: '',
            startDayLimit: '',
            endDayLimit: '',
            rangeDay: [],
            startDay: '',
            endDay: '',
            startDate: '',
            endDate: '',
            period: '',
            recordingFile: null,
            recordingFiles: {
                links: {
                    prev: null,
                    next: null,
                },
                data: [],
                meta: {
                    last_page: 0,
                    current_page: 1,
                    total: 0,
                    per_page: 0,
                },
                load: false,
            },
            videoPlayerComponent: '',
            isPlayerModalOpen: false,
        };
    },
    mounted() {
        $('#playerModal').on('hidden.bs.modal', () => {
            this.videoPlayerComponent = '';
            this.isPlayerModalOpen = false;
        });
        if (this.loadedServiceAccount) {
            this.initialize();
        }
    },
    methods: {
        initialize() {
            this.initSelectableDate('7d');
            this.changePeriod('1d');
            // this.loadRecordFiles(this.recordingFilesApiUri);
            this.loadSelectChannel();
        },
        doSearch() {
            this.setUtcStartEndDateTime();
            this.period = 'custom';

            this.loadRecordFiles(this.recordingFilesApiUri);
        },
        changePeriod(period) {
            this.extractRangeDayFromPeriod(period);
            this.setUtcStartEndDateTime();

            this.loadRecordFiles(this.recordingFilesApiUri);
        },
        loadRecordFiles(recordingFilesApi) {
            if (this.$moment(this.startDay) < this.$moment(this.startDayLimit)) {
                this.$toasted.error(this.$t('paragraphs.channel.select_start_date_bigger', { date: this.startDayLimit }));
                return;
            }

            if (this.$moment(this.endDay) > this.$moment(this.endDayLimit)) {
                this.$toasted.error(this.$t('paragraphs.channel.select_end_date_smaller', { date: this.endDayLimit }));
                return;
            }

            this.recordingFiles.load = false;
            axios.get(recordingFilesApi).then((response) => {
                this.recordingFiles = response.data;
                this.selectAll = false;
                this.recordingFiles.data = this.recordingFiles.data
                    .map(recordingFile => ({ ...recordingFile, selected: this.selectAll }));
                this.recordingFiles.load = true;
            });
        },
        doPlayRecordingFile(recordingFile) {
            // 7일이내 방송만 재생가능하도록 한 로직 제거
            // const nowDate = moment().utc();
            // if (nowDate.subtract(6, 'day') > moment(recordingFile.broadcast_started_at)) {
            //     this.$toasted.error(this.$t('paragraphs.channel.download_in_7days'));
            //     return;
            // }
            this.isPlayerModalOpen = true;
            this.recordingFile = recordingFile;
            this.videoPlayerComponent = 'vueVideoPlayer';

            $('#playerModal').modal({});
        },
        getDownloadUrl(recordingFile) {
            return `/cms/${this.selectedServiceAccount.key}/channels/${recordingFile.channel_id}/recording-files/${recordingFile.id}/download`;
        },
        changeOrder(order) {
            const newOrder = order.match(/^(.*)_(asc|desc)$/);
            const curOrder = this.order.match(/(.*)_(asc|desc)$/);
            if (newOrder.length < 3) {
                return;
            }
            if (curOrder !== null && curOrder.length > 2 && newOrder[1] === curOrder[1]) {
                newOrder[2] = (curOrder[2] === 'asc') ? 'desc' : 'asc';
            }
            this.order = `${newOrder[1]}_${newOrder[2]}`;
            this.loadRecordFiles(this.recordingFilesApiUri);
        },
        doDestroyRecordFiles() {
            if (!this.haveManagerRight) {
                return;
            }
            if (confirm(this.$t('paragraphs.message.confirm.remove_recording_file'))) {
                const selectedRecordingFileIds = this.recordingFiles.data.filter(recordingFile => recordingFile.selected)
                    .map(recordingFile => recordingFile.id);

                if (selectedRecordingFileIds.length === 0) {
                    this.$toasted.error(this.$t('paragraphs.please_select_item'));
                    return;
                }

                axios.delete(`/cms/${this.selectedServiceAccount.key}/recording-files`, { data: { selected_ids: selectedRecordingFileIds } }).then(() => {
                    this.$toasted.success(this.$t('paragraphs.message.success.remove_recording_file'));
                    this.loadRecordFiles(this.recordingFilesApiUri);
                }).catch((error) => {
                    this.$toasted.error(this.$t('paragraphs.message.error.remove_recording_file'));
                    logger.error(error.response.data.errors);
                });
            }
        },
        loadSelectChannel() {
            const self = this;
            const selectizeObj = $('#select_channel').selectize({
                valueField: 'id',
                labelField: 'title',
                searchField: 'title',
                preload: true,
                create: false,
                maxItems: 1,
                onChange(value) {
                    self.selectedChannel = value;
                    self.loadRecordFiles(self.recordingFilesApiUri);

                    // 방송 검색되도록 수정.
                    self.selectize_broadcasts.clear();
                    self.selectedBroadcast = '';
                    self.selectize_broadcasts.onSearchChange('');
                    // self.selectize_broadcasts.clear();
                    // self.selectize_broadcasts.clearOptions();
                    // self.selectize_broadcasts.disable();
                    // self.selectize_broadcasts.load((callback) => {
                    //     if (!value.length) {
                    //         callback([{ id: '', title: self.$t('words.all_broadcasts') }]);
                    //         return;
                    //     }
                    //
                    //     const broadcastUri = `/cms/${self.selectedServiceAccount.key}/channels/${self.selectedChannel}/select_broadcasts`;
                    //     axios.get(broadcastUri).then((response) => {
                    //         self.selectize_broadcasts.enable();
                    //         response.data.data.unshift({ id: '', title: self.$t('words.all_broadcasts') });
                    //         callback(response.data.data);
                    //     }).catch((error) => {
                    //         // self.$toasted.error('Failed to load lives');
                    //         logger.log(error.response.data.errors);
                    //         callback([{ id: '', title: self.$t('words.all_broadcasts') }]);
                    //     });
                    // });

                    // self.selectize_broadcasts.setValue('', true);
                },
                load(query, callback) {
                    this.clearOptions();

                    self.selectedChannel = '';
                    self.selectedBroadcast = '';

                    const uri = `/cms/${self.selectedServiceAccount.key}/select_channels?keyword=${query}`;

                    axios.get(uri).then((response) => {
                        response.data.data.unshift({ id: '', title: self.$t('words.all_channels') });
                        callback(response.data.data);
                    }).catch((error) => {
                        self.$toasted.error('Failed to load channels');
                        logger.log(error.response.data.errors);
                        callback([{ id: '', title: self.$t('words.all_channels') }]);
                    });
                },
            });

            this.selectize_channels = selectizeObj[0].selectize;
            this.loadSelectBroadcast();
        },
        loadSelectBroadcast() {
            const self = this;
            const selectizeObj = $('#select_live').selectize({
                valueField: 'id',
                labelField: 'title',
                searchField: 'title',
                preload: true,
                create: false,
                maxItems: 1,
                onChange(value) {
                    self.selectedBroadcast = value;
                    self.loadRecordFiles(self.recordingFilesApiUri);
                    // if (!value.length) return;
                },
                load(query, callback) {
                    this.clearOptions();
                    if (self.selectedChannel.length === 0) {
                        callback([{ id: '', title: self.$t('words.all_broadcasts') }]);
                        return;
                    }

                    const broadcastUri = `/cms/${self.selectedServiceAccount.key}/channels/${self.selectedChannel}/select_broadcasts?keyword=${query}`;
                    axios.get(broadcastUri).then((response) => {
                        // self.selectize_broadcasts.enable();
                        response.data.data.unshift({ id: '', title: self.$t('words.all_broadcasts') });
                        callback(response.data.data);
                    }).catch((error) => {
                        // self.$toasted.error('Failed to load lives');
                        logger.log(error.response.data.errors);
                        callback([{ id: '', title: self.$t('words.all_broadcasts') }]);
                    });
                },
            });

            this.selectize_broadcasts = selectizeObj[0].selectize;
            // this.selectize_broadcasts.clearOptions();
            // this.selectize_broadcasts.disable();
        },
        getHumanReadableFilesize(filesize) {
            const transGiga = filesize / 1024 / 1024 / 1024;

            return `${Math.round(transGiga * 1000) / 1000}`;
        },
    },
    computed: {
        videoPlayer() {
            return this.$refs.videoPlayer.player;
        },
        recordingFilesApiUri() {
            if (parseInt(this.selectedChannel, 10) > 0) {
                return `/cms/${this.selectedServiceAccount.key}/channels/${this.selectedChannel}` +
                    `/recording-files?page=&broadcast=${this.selectedBroadcast}&order=${this.order}&started_at=${this.startDate}&ended_at=${this.endDate}`;
            }
            return `/cms/${this.selectedServiceAccount.key}` +
                `/recording-files?page=&broadcast=${this.selectedBroadcast}&order=${this.order}&started_at=${this.startDate}&ended_at=${this.endDate}`;
        },
    },
    watch: {
        loadedServiceAccount(newValue) {
            this.initialize();
        },
        selectAll(newValue) {
            this.recordingFiles.data = this.recordingFiles.data
                .map(recordingFile => ({ ...recordingFile, selected: newValue }));
        },
    },
};
</script>

<style>
    .sortable {
        cursor: pointer;
    }
</style>
